// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";
import { menuScroll } from "./onscroll";

const $ = jQuery;

$( () => {

  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );
  $( '.filters-drawer' ).hover(
    function() {
      $( 'body' ).addClass( 'filters-drawer-open' );
    }, function() {
      $( 'body' ).removeClass( 'filters-drawer-open' );
    }
  );
  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );
  function copyToClipboard(text:string) {
    navigator.clipboard.writeText(text)
        .then(function() {
            console.log('URL copied to clipboard: ' + text);
        })
        .catch(function(err) {
            console.error('Unable to copy URL to clipboard', err);
        });
  }
  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

  $( window ).on( 'resize scroll', function ( e ) {
    if ( $( window ).scrollTop() > $( '.page-header.sticky-top' ).height() && !$( '.page-header.sticky-top' ).is( '.scroll' ) ) {
      $( '.page-header.sticky-top' ).addClass( 'scroll' );
    } else if ( $( window ).scrollTop() < $( '.page-header.sticky-top' ).height() && $( '.page-header.sticky-top' ).is( '.scroll' ) ) {
      $( '.page-header.sticky-top' ).removeClass( 'scroll' );
    }
  } );

  $('#field_93_contains').attr('placeholder', 'Search by Sport');
  $('#field_any_contains').attr('placeholder', 'Search for Athletes');
  $('#field_94_contains').attr('placeholder', 'Search by Country');
  $('#field_56_contains').attr('placeholder', 'State');
  $('#charitable_field_donor_comment_element').attr('placeholder', 'Your Message...');



  $( "#filters-drawer" ).mouseenter(function() {
  $(this).find('.navbar-nav').children('.menu-item').addClass('expanded');
});
  $( "#filters-drawer" ).mouseleave(function() {
  $(this).find('.navbar-nav').children('.menu-item').removeClass('expanded');
});

  $( ".profile-edit .bp-subnavs" ).mouseenter(function() {
  $(this).find('.subnav li').addClass('expanded');
});
  $( ".profile-edit .bp-subnavs" ).mouseleave(function() {
  $(this).find('.subnav li').removeClass('expanded');
});

 $( ".settings .bp-subnavs" ).mouseenter(function() {
  $(this).find('.subnav li').addClass('expanded');
});
  $( ".settings .bp-subnavs" ).mouseleave(function() {
  $(this).find('.subnav li').removeClass('expanded');
});

 $( ".change-avatar .bp-subnavs" ).mouseenter(function() {
  $(this).find('.subnav li').addClass('expanded');
});
  $( ".change-avatar .bp-subnavs" ).mouseleave(function() {
  $(this).find('.subnav li').removeClass('expanded');
});

$( ".change-cover-image .bp-subnavs" ).mouseenter(function() {
  $(this).find('.subnav li').addClass('expanded');
});
$( ".change-cover-image .bp-subnavs" ).mouseleave(function() {
  $(this).find('.subnav li').removeClass('expanded');
});

  $( ".accordion-button" ).click(function() {
  $(this).parent().toggleClass('expanded');
});

} );
